import React from "react";
import { FormattedMessage, FormattedDateParts } from "react-intl";
import { getTimeLeft } from "../../utils/get-time-left";

import styles from "./styles.modules.scss";

const getFormattedMessageProps = (
    timeStamp: number,
    limitInMilliseconds: number,
): undefined | { id: string; values: Record<string, number> } => {
    const timeSinceNow = Date.now() - timeStamp;
    const { days, hours, minutes } = getTimeLeft(timeSinceNow);

    const { totalDays, totalHours, totalMinutes } =
        getTimeLeft(limitInMilliseconds);

    const getProps = (id: string, x: number) => ({
        id: `globalText.${id}`,
        values: {
            x,
        },
    });

    if (timeSinceNow < 0 || timeSinceNow > limitInMilliseconds) {
        return undefined;
    }

    if (days && days < totalDays) {
        return getProps(days > 1 ? "langDaysAgo" : "langDayAgo", days);
    }

    if (hours && hours < totalHours) {
        return getProps(hours > 1 ? "langHoursAgo" : "langHourAgo", hours);
    }

    if (minutes && minutes < totalMinutes) {
        return getProps(
            minutes > 1 ? "langMinutesAgo" : "langMinuteAgo",
            minutes,
        );
    }

    return getProps("langMinutesAgo", 0);
};

export const DateOrTime = ({
    timeStamp,
    limitInMilliseconds,
    includeStyles = true,
}: {
    timeStamp: number;
    limitInMilliseconds: number;
    includeStyles?: boolean;
}) => {
    const formattedMessageProps = getFormattedMessageProps(
        timeStamp,
        limitInMilliseconds,
    );

    return (
        <div
            className={`date-or-time ${includeStyles ? styles.dateOrTime : ""}`}
        >
            {formattedMessageProps ? (
                <FormattedMessage {...formattedMessageProps} />
            ) : (
                <FormattedDateParts
                    day="2-digit"
                    month="long"
                    value={timeStamp}
                >
                    {([month, monthLiteral, day, dayLiteral]) => {
                        return (
                            <>
                                <div
                                    className={`month ${includeStyles ? styles.month : ""}`}
                                >
                                    {month?.value}
                                </div>

                                <div
                                    className={`literal ${includeStyles ? styles.literal : ""}`}
                                >
                                    {monthLiteral?.value}
                                </div>

                                {day?.value && (
                                    <div
                                        className={`day ${includeStyles ? styles.day : ""}`}
                                    >
                                        {day.value}

                                        {dayLiteral?.value ?? ""}
                                    </div>
                                )}
                            </>
                        );
                    }}
                </FormattedDateParts>
            )}
        </div>
    );
};
